import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box, IconButton } from "@material-ui/core";
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import { makeStyles } from '@material-ui/styles';
import PersonIcon from '@mui/icons-material/Person';
import ItemList from '../../component/ItemList/index';
import FooterBar from '../../component/FooterAtom/index'
import SliderOne from './../../img/chana.jpg';
import Drawer from '@material-ui/core/Drawer';
import EditPost from './../../pages/Editpost/EditPost';
import firebase from "../../config/firebase/index";
import { useHistory } from 'react-router-dom';
import { margin } from '@mui/system';
import ReactGA from 'react-ga';
import encSecret from '../../config/encryption/index.js';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
var CryptoJS = require("crypto-js");


const Createpost_Repeatuser = () => {
    const classes = useStyles();
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [createOpen, setCreateOpen] = useState(false);
    const [deals, setDeals] = useState([]);
    const [selectedDeal, setSelectedDeal] = useState("");
    // const [state, setState] = useState(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const [date, setDate] = useState(new Date());
    const isDealer = user[0].dealerFlag;
    const search = useLocation().search;
    const create = new URLSearchParams(search).get("create");
    const newDealCreation = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const dealEditOrDuplicated = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const toggleDrawer = (dealid, date) => {
        // console.log(dealid)
        if (dealid) {
            setSelectedDeal(dealid)
            setDate(date);
        }
        setOpen(true);
    };

    const createToggleDrawer = () => {
        // console.log(dealid)
        setCreateOpen(true);
    };


    const AllDeals = () => {
        firebase.database().ref("Product").orderByChild("DealerNumber")
            .equalTo(localStorage.getItem("Phone Number")).on("value", snapshot => {

                const dealData = snapshot.val();

                const tempDeals = [];
                for (const key in dealData) {

                    const dealObj = {
                        id: key,
                        ...dealData[key],
                    };
                    tempDeals.push(dealObj);
                }
                console.log(tempDeals);
                setDeals(tempDeals);

            })
    }

    useEffect(() => {
        AllDeals();
        if(create)
            createToggleDrawer()
    }, []);



    return (
        <Grid p={2} className={classes.commonSectionBuild}>
            <NoFollowMeta />
            <Box className={classes.headerBrowser1}>
                <Typography variant="h6" style={{ fontWeight: 600 }} className={classes.commonNameCenter}>
                    सौदा बनाये
                </Typography>
                <IconButton onClick={() => history.push('/profile')}>

                    <PersonIcon fontSize="large" />
                </IconButton>
            </Box>

            <Typography className={classes.border}></Typography>

            <Box className={classes.headerBrowser2}>
                {/* <SearchIcon className={classes.headerBrowser3}/>
                <TextfieldAtom  placeholder="यहाँ search करे   " /> */}
            </Box>

            <Box className={classes.headerBrowser1}>
                <Typography variant="h6" style={{ fontWeight: 602 }}>
                    हाल के सौदे
                </Typography>

            </Box>
            <Grid container className={classes.headerBrowser}>
                {deals && deals.map((item, index) => (
                    <Grid key={index} item xs={12} className={classes.contentBox} >
                        
                            <Box ml={1} >
                                <ItemList key={index}
                                    dealId={item.DealId}
                                    productName={item.productName}
                                    minPrice={CryptoJS.AES.decrypt(item.Min, encSecret.key).toString(CryptoJS.enc.Utf8)}
                                    maxPrice={CryptoJS.AES.decrypt(item.Max, encSecret.key).toString(CryptoJS.enc.Utf8)}
                                    place={item.Place}
                                    image={<img width="100%" src={item.image} alt="" style={{ marginTop: '20px' }} />}
                                />
                            </Box>
                            <Box mt={3} className={classes.upperBar}>
                                <ButtonAtom
                                    label="edit करे"
                                    name="edit करे"
                                    onClick={() =>  { dealEditOrDuplicated('Duplicate Deal', 'Click', 'Edit Deal'); toggleDrawer(item.DealId, item.createdAt.split(" ")[0])}}
                                />
                            </Box>
                       
                    </Grid>
                )).reverse()}
            </Grid>

            <Box>
                <br />
                <Typography className={classes.text}>या </Typography>
                <br />
            </Box>

            <Box mb={3} style={{ marginBottom: '100px' }}>
                <ButtonAtom
                    label="नया सौदा बनाएं"
                    name="नया सौदा बनाएं"
                    cclass="templateButton2"
                    onClick={() =>  { newDealCreation('New Deal', 'Click', 'Create New Deal'); createToggleDrawer()}}
                />
            </Box>

            <Box>
                <FooterBar isDealer={isDealer} active={[0,1,0,0]} />
            </Box>

            <div>

                <React.Fragment>
                    <Drawer className={classes.drawerDesign} anchor={'bottom'} open={open}>
                        <EditPost closePopUp={setOpen} dealId={selectedDeal} date = {date}/>
                    </Drawer>
                </React.Fragment>

            </div>
            <div>

                <React.Fragment>
                    <Drawer className={classes.drawerDesign} anchor={'bottom'} open={createOpen}>
                        <EditPost closePopUp={setCreateOpen} />
                    </Drawer>
                </React.Fragment>

            </div>


        </Grid>

    )
};

const useStyles = makeStyles(() => ({
    contentBox: {
        background: '#fff',
        padding: '0px',
        boxSizing: 'border-box',
        marginLeft:'-5px',
        marginRight:'-5px',
    },
    upperBar: {
        marginTop: '20px',
        marginBottom: '5px',
    },
    drawerDesign: {
        '& .MuiDrawer-paper': {
            paddingTop: 20,
            borderRadius: '40px 40px 0 0',
            boxSizing: 'border-box',
        }
    },
    headerBrowser: {
        background: '#fff',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 0',
        alignItems: 'center',
        boxSizing: 'border-box',
        overflowX: 'auto',
        '& > .MuiBox-root': {
            minWidth: '40%',
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '0 auto',
        padding: '0 15px',
        boxSizing: 'border-box',
    },
    text: {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',

    },
    headerBrowser1: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        alignItems: 'center',
        boxSizing: 'border-box',
        position: 'relative',
        '& input': {
            paddingLeft: 50,
        }

    },
    commonNameCenter: {
        alignItems: 'center',
        marginLeft: '80px',
        // marginRight: '0px',
        size: '10px',
    },
    headerBrowser3: {
        position: 'absolute',
        top: 25,
        left: 30,
    },
    border: {
        borderBottom: 'solid 1px #ddd',

    }

}));

export default Createpost_Repeatuser;